import { StoreLayout } from "../../components/StoreLayout";
import { Link } from "react-router-dom";
import { ShieldCheck, Users, MapPin, Sparkle, Wrench, HeartStraight, CheckCircle } from "@phosphor-icons/react";

const VALUES = [
  { icon: ShieldCheck, title: "Verified Professionals", desc: "Every partner is background-checked, trained and rated by real customers." },
  { icon: Sparkle, title: "Transparent Pricing", desc: "Upfront rates with no hidden charges — you always know what you'll pay." },
  { icon: HeartStraight, title: "30-Day Service Warranty", desc: "If the same issue recurs, we re-attend at no extra labour cost." },
  { icon: Wrench, title: "All Home Services", desc: "AC, appliances, cleaning, plumbing, electrical, pest control and more — one trusted app." },
];

const STATS = [
  { v: "20,000+", l: "Jobs completed" },
  { v: "4.1★", l: "Average rating" },
  { v: "500+", l: "Verified partners" },
  { v: "Pan-India", l: "& growing" },
];

export default function About() {
  return (
    <StoreLayout>
      <div className="max-w-5xl mx-auto px-4 py-14" data-testid="about-page">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-[#eef2ff] text-[#4F46E5] text-xs font-bold tracking-wide mb-4">ABOUT FIXIGO</span>
          <h1 className="font-[Outfit] text-4xl md:text-5xl font-extrabold tracking-tight">Home services, made effortless.</h1>
          <p className="text-[#475569] text-lg mt-4 leading-relaxed">
            Fixigo Home Services is India's trusted home-services marketplace. We connect you with verified, skilled professionals for AC & appliance repair, home cleaning, plumbing, electrical work, pest control and more — booked online in minutes, with honest pricing and a service you can rely on.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
          {STATS.map((s, i) => (
            <div key={i} className="text-center bg-white border border-[#E2E8F0] rounded-2xl py-6">
              <p className="font-[Outfit] text-3xl font-extrabold text-[#4F46E5]">{s.v}</p>
              <p className="text-sm text-[#475569] mt-1">{s.l}</p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center mt-16">
          <div>
            <h2 className="font-[Outfit] text-2xl font-extrabold tracking-tight mb-3">Our Mission</h2>
            <p className="text-[#475569] leading-relaxed">
              Getting a reliable technician home shouldn't be stressful. We started Fixigo to fix exactly that — bringing transparency, trained professionals and technology together so every home gets quality service at a fair price, every single time.
            </p>
            <p className="text-[#475569] leading-relaxed mt-3">
              From instant booking and doorstep pickup to secure online payments and real-time job tracking, we're building the most dependable home-services experience in India.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-3">
            {VALUES.map((v, i) => (
              <div key={i} className="flex gap-3 bg-white border border-[#E2E8F0] rounded-xl p-4">
                <div className="w-10 h-10 rounded-lg bg-[#eef2ff] flex items-center justify-center shrink-0"><v.icon size={20} weight="fill" className="text-[#4F46E5]" /></div>
                <div>
                  <p className="font-bold text-[#1e293b]">{v.title}</p>
                  <p className="text-sm text-[#475569]">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-[#4F46E5] rounded-2xl p-8 md:p-10 text-center text-white">
          <h2 className="font-[Outfit] text-2xl md:text-3xl font-extrabold">Ready to book a service?</h2>
          <p className="text-white/80 mt-2">Verified professionals, upfront prices, and a 30-day service warranty.</p>
          <Link to="/services" data-testid="about-cta" className="inline-block mt-5 bg-white text-[#4F46E5] font-bold rounded-xl px-6 py-3 hover:bg-white/90 transition-colors">Explore Services</Link>
        </div>

        <p className="text-center text-sm text-[#94a3b8] mt-10">Fixigo Home Services — a business division of Mauli Enterprises.</p>
      </div>
    </StoreLayout>
  );
}
